import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import Helmet from 'react-helmet';
import map from 'lodash/map';
import compact from 'lodash/compact';
import Assets, { isFilename } from './Assets';

interface Props {
	preloadImages?: boolean;
	preloadSounds?: boolean;
}

const AssetsPreloader: FunctionComponent<Props> = (props: Props) => {
	const { preloadImages = true, preloadSounds = false } = props;

	const imagePreloadLinks = useMemo(() => {
		if (preloadImages) {
			return compact(
				map(Assets.images, (value, key) => {
					if (isFilename(value)) {
						return (
							<link
								key={`image_${key}`}
								rel="preload"
								href={value}
								as="image"
							/>
						);
					}
					return undefined;
				})
			);
		} else {
			return [];
		}
	}, [preloadImages]);

	const soundPreloadLinks = useMemo(() => {
		if (preloadSounds) {
			return compact(
				map(Assets.sounds, (value, key) => {
					if (isFilename(value)) {
						return (
							<link
								key={`sound_${key}`}
								rel="preload"
								href={value}
								as="audio"
							/>
						);
					}
					return undefined;
				})
			);
		} else {
			return [];
		}
	}, [preloadSounds]);

	return (
		<Helmet>
			{imagePreloadLinks}
			{soundPreloadLinks}
		</Helmet>
	);
};

export default AssetsPreloader;
